export default "/_next/static/d6172bd55bf842e66bc02118128cb27c.png";